import { JwtClaims } from 'oidc-client-ts';

export interface UserProfile extends JwtClaims {
    [key: string]: any;
}

export interface ClaimSettings {
    mergeClaimsStrategy: {
        array: 'replace' | 'merge';
    };
}

export class ClaimService {
    private _settings: ClaimSettings;

    constructor(settings: ClaimSettings = { mergeClaimsStrategy: { array: 'merge' } }) {
        this._settings = settings;
    }

    public mergeClaims(claims1: JwtClaims, claims2: JwtClaims): UserProfile;
    public mergeClaims(claims1: UserProfile, claims2: JwtClaims): UserProfile {
        const result = { ...claims1 };
        for (const [claim, values] of Object.entries(claims2)) {
            if (result[claim] !== values) {
                if (Array.isArray(result[claim]) || Array.isArray(values)) {
                    if (this._settings.mergeClaimsStrategy.array === "replace") {
                        result[claim] = values;
                    } else {
                        const mergedValues = Array.isArray(result[claim]) ? result[claim] as unknown[] : [result[claim]];
                        for (const value of Array.isArray(values) ? values : [values]) {
                            if (!mergedValues.includes(value)) {
                                mergedValues.push(value);
                            }
                        }
                        result[claim] = mergedValues;
                    }
                } else if (typeof result[claim] === "object" && typeof values === "object") {
                    result[claim] = this.mergeClaims(result[claim] as JwtClaims, values as JwtClaims);
                } else {
                    result[claim] = values;
                }
            }
        }

        return result;
    }
}
